// src/router/admin.router.js
import { Route } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "../components/ProtectedRoute";

// Lazy imports
const DashboardPrincipalAdmin = lazy(() => import("../layouts/admin/DashboardPrincipalAdmin"));
const UsuariosDashboardAdmin = lazy(() => import("../layouts/admin/UsuariosDashboardAdmin"));
const CreateUsuariosAdmin = lazy(() => import("../layouts/admin/create/CreateUsuariosAdmin"));
const DispositivosAdminDashboard = lazy(() => import("../layouts/admin/DispositivosAdminDashboard"));
const CrearDispositivoRFID = lazy(() => import("../layouts/admin/create/CreateDispositivoRFID"));
const EmpresasDashboard = lazy(() => import("../layouts/admin/EmpresasDashboard"));
const CreateEmpresas = lazy(() => import("../layouts/admin/create/CreateEmpresas"))
const APKDashboard = lazy(() => import("../layouts/admin/APKDashboard"))

export default function AdminRoutes() {
  return (
    <>
      <Route
        path="/home/admin"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <DashboardPrincipalAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboardusersadmin"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <UsuariosDashboardAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboardusersadmin/crear"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <CreateUsuariosAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboardusersadmin/editar/:id"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <CreateUsuariosAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rfidsadmin"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <DispositivosAdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rfidsadmin/crear"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <CrearDispositivoRFID />
          </ProtectedRoute>
        }
      />
      <Route
        path="/rfidsadmin/editar/:id"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <CrearDispositivoRFID />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboardempresasadmin"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <EmpresasDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboardempresasadmin/crear"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <CreateEmpresas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboardempresasadmin/editar/:id"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <CreateEmpresas />
          </ProtectedRoute>
        }
      />


      <Route
        path="/apk"
        element={
          <ProtectedRoute allowedRoles={["ADMIN"]}>
            <APKDashboard />
          </ProtectedRoute>
        }
      />
    </>
  );
}